// extracted by mini-css-extract-plugin
export default {"root":"Marquee_root__CzhP7","item":"Marquee_item__mwHkA","marqueeIcon":"Marquee_marqueeIcon__rg8bp"};